import { clearAllBlobs } from '../store/blob-store';

export const CleanStudyProcess = () => {
	//TODO create a custom hook or something to add here the remove all files action
	clearAllBlobs();
};
